var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemezLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 166,
    viewBox: "0 0 160 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 85.3927,
    rx: 8,
    fill: "#F0F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 36C70.4694 36 61.9266 40.1112 56 46.6785L80 89.3927L104 46.6785C98.1001 40.1379 89.5306 36 80 36ZM80 78.5006L62.6741 47.6396C67.5061 43.6085 73.6463 41.3393 80 41.3393C86.3537 41.3393 92.4939 43.6085 97.3259 47.6396L80 78.5006ZM71.9911 45.3437C69.7753 45.3437 67.9867 47.1324 67.9867 49.3482C67.9867 51.564 69.7753 53.3526 71.9911 53.3526C74.2069 53.3526 75.9956 51.564 75.9956 49.3482C75.9956 47.1324 74.1802 45.3437 71.9911 45.3437ZM75.9956 65.366C75.9956 67.5818 77.7842 69.3704 80 69.3704C82.1891 69.3704 84.0044 67.5818 84.0044 65.366C84.0044 63.1502 82.1891 61.3615 80 61.3615C77.8109 61.3615 75.9956 63.1502 75.9956 65.366Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 165.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemezLight);
export default __webpack_public_path__ + "static/media/MemezLight.267e442c0f712ca6246b6e4fab5660f1.svg";
export { ForwardRef as ReactComponent };